import L from 'leaflet';

// Generate Task SVG icon
const createTaskIcon = () => {
  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="#0d3825"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="white"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- Task icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(2.2) translate(-30, -30)">
        <g transform="scale(0.1333)">
          <g transform="translate(0, 450) scale(0.1, -0.1)" fill="#0d3825">
            <path d="M1600 2765 c-19 -7 -43 -14 -53 -14 -42 -2 -192 -79 -267 -136 -347 -268 -430 -738 -194 -1111 74 -118 278 -287 374 -311 14 -3 30 -9 35 -14 6 -4 49 -17 96 -28 268 -65 556 17 753 212 107 108 150 175 211 337 28 72 39 148 39 255 0 287 -137 542 -374 695 -78 50 -185 100 -217 100 -10 0 -36 7 -58 15 -53 19 -295 19 -345 0z m370 -120 c251 -84 424 -264 494 -517 23 -81 21 -259 -3 -347 -69 -250 -263 -446 -511 -517 -87 -25 -270 -25 -355 0 -246 73 -421 244 -504 493 -30 90 -30 306 0 396 62 185 169 321 334 424 48 30 173 77 230 86 67 11 260 0 315 -18z"/>
            <path d="M1670 2620 c-164 -38 -263 -91 -366 -194 -70 -70 -144 -181 -144 -215 0 -9 -5 -22 -12 -29 -11 -11 -21 -54 -37 -167 -10 -72 11 -242 36 -290 5 -11 19 -38 29 -60 62 -130 169 -240 299 -305 49 -24 107 -47 130 -51 22 -4 70 -13 107 -20 54 -10 79 -10 130 0 35 7 81 16 103 20 22 4 49 12 60 18 11 6 38 20 60 30 68 32 119 69 182 130 59 59 143 189 143 222 0 9 5 22 11 28 14 14 39 153 39 218 0 184 -80 369 -212 490 -61 56 -167 125 -192 125 -6 0 -16 4 -21 9 -6 6 -28 14 -50 20 -22 5 -58 15 -80 20 -46 12 -164 12 -215 1z m295 -68 c28 -10 64 -25 80 -33 148 -70 273 -215 325 -378 28 -88 28 -283 1 -363 -47 -136 -123 -244 -225 -321 -119 -90 -210 -119 -371 -120 -120 -1 -165 8 -270 55 -134 58 -263 205 -321 364 -21 59 -25 87 -26 196 0 129 8 175 51 268 83 178 269 322 456 353 65 11 249 -2 300 -21z"/>
            <path d="M2025 2228 c-125 -136 -347 -358 -357 -358 -5 0 -44 32 -86 70 -42 39 -82 70 -91 70 -16 0 -111 -94 -111 -109 0 -19 283 -291 303 -291 14 0 77 63 328 331 155 164 219 239 219 255 0 21 -92 104 -115 104 -15 0 -45 -25 -90 -72z"/>
            <path d="M2716 2419 c-33 -26 -34 -68 -3 -97 23 -22 24 -22 504 -22 l481 0 16 25 c24 36 20 70 -10 94 -26 21 -36 21 -494 21 -458 0 -468 0 -494 -21z"/>
            <path d="M2717 2040 c-34 -27 -36 -71 -5 -100 21 -20 33 -20 498 -20 l477 0 21 23 c28 29 28 68 1 93 -20 18 -45 19 -493 22 -467 3 -473 2 -499 -18z"/>
            <path d="M2712 1637 c-28 -30 -28 -68 1 -95 23 -22 24 -22 500 -22 l476 0 21 22 c28 31 26 72 -6 97 -26 21 -36 21 -499 21 l-472 0 -21 -23z"/>
          </g>
        </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const IconTask = () => {
  var icon = new L.Icon({
    iconUrl: createTaskIcon(),
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [94, 104],
    iconAnchor: [34, 75],
    className: 'custom-icon-marker task-marker'
  });

  return icon;
};
